// extracted by mini-css-extract-plugin
export default {"scroll":"PopupNotifications_scroll__DUfKB","tableWrapper":"PopupNotifications_tableWrapper__y8SZ9"};